import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, experience, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
        </div>
        <div className="sub-image two">
          <img src={image.src2} alt={image.alt2} />
          <div className='experience-container'>
            <div className='experience'><span>{experience.year}</span> {experience.text}</div>
          </div>
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Key Features */}
        <div className="about-points">
          {points.map((point, index) => (
            <ul key={index}>
              <li>
                <div className='icon'>{point.icon}</div> {/* Feature Icon */}
                <div className='text'>
                  <h5>{point.title}</h5> {/* Feature Title */}
                  <p>{point.content}</p> {/* Feature Content */}
                </div>
              </li>
            </ul>
          ))}
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;